<template>
  <div>
    <div class="card-header">
      <div class="card-header-left">
        <h5>Stage 2 Processes</h5>
        <br />
      </div>
    </div>
    <div class="card-block">
      <div class="row">
        <div
          class="col-sm-9"
          v-if="$checkPerm('application.view_applicant_submissions')"
        >
          <div class="accordion" id="processes">
            <div
              v-for="(process, index) in $parent.applicant_processes"
              class="card"
            >
              <div
                v-if="process.process == 'Video Upload'"
                class="card-header"
                v-bind:id="'heading' + index"
              >
                <h2 class="mb-0">
                  <button
                    class="btn btn-link"
                    type="button"
                    data-toggle="collapse"
                    v-bind:data-target="'#collapse' + index"
                    aria-expanded="true"
                    v-bind:aria-controls="'collapse' + index"
                  >
                    Video Upload
                  </button>
                </h2>

                <div
                  v-bind:id="'collapse' + index"
                  class="collapse"
                  v-bind:aria-labelledby="'heading' + index"
                  data-parent="#processes"
                >
                  <div class="card-body">
                    <AppVideo
                      v-bind:applicant_documents="$parent.applicant.documents"
                      v-bind:opening="$parent.opening_id"
                    />
                  </div>
                </div>
              </div>

              <div
                class="card-header"
                v-bind:id="'heading' + index"
                v-else-if="process.process == 'CBT'"
              >
                <div class="d-flex justify-between">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link"
                      v-bind:class="{ 'cbt-tab-active': activeCbtTab == 'cbt' }"
                      type="button"
                      v-bind:aria-expanded="activeCbtTab == 'cbt' ? 'true' : 'false'"
                      v-bind:aria-controls="'collapse' + index"
                      v-on:click="toggleCbt"
                    >
                      {{ process.process }}
                    </button>
                  </h2>

                  <h2 class="mb-0">
                    <button
                      class="btn btn-link"
                      v-bind:class="{ 'cbt-tab-active': activeCbtTab == 'recording' }"
                      type="button"
                      v-on:click="toggleCbtRecording($parent.applicant_id)"
                    >
                      CBT Recording
                    </button>
                  </h2>

                  <h2 class="mb-0">
                    <button
                      class="btn btn-link"
                      v-bind:class="{ 'cbt-tab-active': activeCbtTab == 'comments' }"
                      type="button"
                      v-on:click="toggleCbtComment($parent.applicant_id)"
                    >
                      CBT Recording Comments
                    </button>
                  </h2>
                </div>
                <div v-if="activeCbtTab == 'recording'" class="p-2">
                  <p v-if="cbtRecordingLoading">Loading recording...</p>
                  <p v-else-if="!cbtRecording || !cbtRecording.link">
                    No CBT recording was found for this applicant.
                  </p>
                  <div v-else>
                    <button
                      class="btn btn-primary btn-sm m-1"
                      type="button"
                      v-on:click="viewCbtRecording"
                    >
                      View
                    </button>
                    <button
                      class="btn btn-danger btn-sm m-1"
                      type="button"
                      v-on:click="deleteCbtRecording($parent.applicant_id)"
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <div v-if="activeCbtTab == 'comments'" class="p-2">
                  <p v-if="cbtCommentsLoading">Loading comments...</p>
                  <p v-else-if="cbtComments.length == 0">No comments yet.</p>
                  <ul v-else class="list-group m-b-10">
                    <li
                      v-for="(item, i) in cbtComments"
                      v-bind:key="item.id || i"
                      class="list-group-item"
                    >
                      <div>{{ item.comment }}</div>
                      <small v-if="item.created_at" class="text-muted">
                        {{ item.created_at }}
                      </small>
                    </li>
                  </ul>
                  <button
                    v-if="!showCbtCommentInput"
                    class="btn btn-primary btn-sm"
                    type="button"
                    title="Add comment"
                    v-on:click="showCbtCommentInput = true"
                  >
                    + Add Comment
                  </button>
                  <form
                    v-else
                    v-on:submit.prevent="submitCbtRecordingComment($parent.applicant_id)"
                  >
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        rows="4"
                        v-model="cbtComment"
                        placeholder="Type your comment here..."
                        required="required"
                      ></textarea>
                    </div>
                    <button class="btn btn-primary btn-sm m-1" type="submit">
                      Submit
                    </button>
                    <button
                      class="btn btn-secondary btn-sm m-1"
                      type="button"
                      v-on:click="cancelCbtComment"
                    >
                      Cancel
                    </button>
                  </form>
                </div>
                <div
                  v-show="activeCbtTab == 'cbt'"
                  v-bind:id="'collapse' + index"
                  v-bind:aria-labelledby="'heading' + index"
                >
                  <div class="card-body">
                    <ApplicantCBT
                      v-bind:applicant_id.number="$parent.applicant_id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="image-holder">
            <img src="assets/img/user-icon.jpg" alt="" class="p-b-10" />
          </div>
          <div class="contact-icon">
            <p>
              <b>Stage Actions</b>
            </p>

            <button
              v-if="$checkPerm('application.approve_for_interview')"
              data-toggle="modal"
              data-target="#interviewStageModal"
              class="btn btn-primary btn-sm m-1"
            >
              Approve for Technical Interview Stage
            </button>

            <button
              class="btn btn-warning btn-sm m-1"
              data-toggle="modal"
              data-target="#star"
              v-if="
                $parent.applicant.is_starred == '0' &&
                $checkPerm('application.archive')
              "
            >
              Keep In View
            </button>

            <button
              class="btn btn-warning btn-sm m-1"
              data-toggle="modal"
              data-target="#star"
              v-if="
                $parent.applicant.is_starred == '1' &&
                $checkPerm('application.unarchive')
              "
            >
              Unarchive Applicant
            </button>

            <button
              v-if="$checkPerm('application.discontinue')"
              class="btn btn-danger btn-sm m-1"
              v-on:click="$parent.deleteApplicant()"
            >
              Discontinue Application
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="$checkPerm('application.approve_for_interview')"
      id="interviewStageModal"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Approve
              {{
                $parent.applicant.firstname + " " + $parent.applicant.lastname
              }}
              for Interview Stage.
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body project-task">
            <form role="form" v-on:submit.prevent="interviewStage">
              <div class="form-group">
                <label><b>Interview Location</b></label>
                <input
                  type="text"
                  class="form-control"
                  name="location"
                  v-model="interview_info.location"
                  required="required"
                  placeholder="Interview Location"
                />
              </div>
              <div class="form-group">
                <label><b>Interview Mode</b></label>
                <select
                  class="form-control"
                  name="mode"
                  v-model="interview_info.mode"
                  required="required"
                >
                  <option value="" disabled>Select Interview Mode</option>
                  <option value="Physical">Physical</option>
                  <option value="Virtual">Virtual</option>
                </select>
              </div>
              <div class="form-group">
                <label><b>Interview Date</b></label>
                <input
                  type="date"
                  class="form-control"
                  name="date"
                  v-model="interview_info.date"
                  required="required"
                />
              </div>
              <div class="form-group">
                <label><b>Interview Time</b></label>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Start Time</label>
                      <input
                        type="time"
                        class="form-control"
                        name="start_time"
                        v-model="interview_info.time1"
                        required="required"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>End Time</label>
                      <input
                        type="time"
                        class="form-control"
                        name="start_time"
                        v-model="interview_info.time2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label><b>Requirements</b></label>
                <summernote
                  height="300"
                  :model.sync="interview_info.requirements"
                ></summernote>
              </div>
              <div class="form-group">
                <button class="btn btn-md btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import AppVideo from "../AppVideo.vue";
import ApplicantCBT from "../CBT/ApplicantCBT.vue";
import summernote from "../Summernote.vue";

export default {
  name: "Stage2",
  data() {
    return {
      showCbtCommentInput: false,
      cbtRecording: null,
      cbtRecordingLoading: false,
      cbtComment: "",
      cbtComments: [],
      activeCbtTab: "",
      cbtCommentsLoading: false,
      interview_info: {
        location: "",
        mode: "",
        date: "",
        time1: "",
        time2: "",
        time: "",
        requirements: "",
        process_id: "3",
        interview_stage: "1",
        applicant_id: this.$route.params.applicant_id,
        joblisting_id: this.$route.params.id,
      },
    };
  },
  methods: {
    getFile(file) {
      return file.includes("https://") ? file : "https://wajesmarthrms.website" + file;
    },

    toggleCbt() {
      this.cancelCbtComment();
      this.activeCbtTab = this.activeCbtTab == "cbt" ? "" : "cbt";
    },

    toggleCbtRecording(applicantId) {
      this.cancelCbtComment();
      if (this.activeCbtTab == "recording") {
        this.activeCbtTab = "";
        return;
      }
      this.activeCbtTab = "recording";
      this.getCbtRecording(applicantId);
    },

    getCbtRecording(applicantId) {
      this.cbtRecordingLoading = true;
      this.cbtRecording = null;
      this.$socket
        .makeGetRequest({
          what: "GetCBTRecording",
          params: { applicant_id: applicantId },
          showLoader: false,
        })
        .then((response) => {
          this.cbtRecording = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.cbtRecordingLoading = false;
        });
    },

    viewCbtRecording() {
      window.open(this.getFile(this.cbtRecording.link), "_blank");
    },

    deleteCbtRecording(applicantId) {
      this.$swal
        .fire({
          title: "Delete CBT Recording?",
          text: "This action cannot be undone.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Delete",
          confirmButtonColor: "#d33",
        })
        .then((result) => {
          if (!result.value) return;

          this.$socket
            .makeDeleteRequest({
              what: "deleteCbtRecording",
              id: applicantId,
            })
            .then(() => {
              this.cbtRecording = null;
              this.$swal.fire(
                "Deleted",
                "CBT recording deleted successfully.",
                "success",
              );
            })
            .catch((error) => {
              console.log(error);
              this.$swal.fire(
                "Error",
                "Unable to delete the CBT recording.",
                "error",
              );
            });
        });
    },

    toggleCbtComment(applicantId) {
      this.cancelCbtComment();
      if (this.activeCbtTab == "comments") {
        this.activeCbtTab = "";
        return;
      }
      this.activeCbtTab = "comments";
      this.getCbtRecordingComments(applicantId);
    },

    getCbtRecordingComments(applicantId) {
      this.cbtCommentsLoading = true;
      return this.$socket
        .makeGetRequest({
          what: "GetCBTRecordingComment",
          params: {
            applicant_id: applicantId,
            joblisting_id: this.$route.params.id,
          },
          showLoader: false,
        })
        .then((response) => {
          var data = response.data;
          if (Array.isArray(data)) {
            this.cbtComments = data;
          } else {
            this.cbtComments = data ? [data] : [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.cbtComments = [];
        })
        .finally(() => {
          this.cbtCommentsLoading = false;
        });
    },

    cancelCbtComment() {
      this.showCbtCommentInput = false;
      this.cbtComment = "";
    },

    submitCbtRecordingComment(applicantId) {
      if (!this.cbtComment.trim()) return;

      this.$socket
        .makePostRequest({
          what: "cbtRecordingComment",
          data: {
            applicant_id: applicantId,
            joblisting_id: this.$route.params.id,
            comment: this.cbtComment.trim(),
          },
        })
        .then(() => {
          this.$swal.fire(
            "Success",
            "Comment submitted successfully.",
            "success",
          );
          this.cancelCbtComment();
          this.getCbtRecordingComments(applicantId);
        })
        .catch((error) => {
          console.log(error);
          this.$swal.fire("Error", "Unable to submit the comment.", "error");
        });
    },

    interviewStage() {
      //This also approves applicant for Stage 3
      this.interview_info.time =
        this.interview_info.time1 + " - " + this.interview_info.time2;
      var interview = {
        what: "InterviewInformation",
        data: this.interview_info,
      };

      this.$socket
        .makePostRequest(interview)
        .then((response) => {
          if (response.type == "InterviewInformation") {
            this.$swal.fire(
              "Success",
              "Applicant approved for next stage.",
              "success",
            );

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {},
  components: {
    AppVideo,
    ApplicantCBT,
    summernote,
  },
};
</script>

<style scoped>
.cbt-tab-active {
  border-bottom: 2px solid #016734;
  border-radius: 0;
}
</style>
